module.exports = "/assets/data/3656f1f6e76db459d05e4e42e0ccdc6f-EN4.data.json";